export const BODYDCODI_PLUS_URL = process.env.REACT_APP_API?.includes("dev")
  ? "https://dev-plus.bodycodi.com"
  : "https://plus.bodycodi.com";
